import { render, staticRenderFns } from "./DvNav.vue?vue&type=template&id=4cddb50d&scoped=true"
import script from "./DvNav.vue?vue&type=script&lang=js"
export * from "./DvNav.vue?vue&type=script&lang=js"
import style0 from "./DvNav.vue?vue&type=style&index=0&id=4cddb50d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cddb50d",
  null
  
)

export default component.exports